import Close20 from '@carbon/icons-react/es/close/20';
// eslint-disable-next-line no-restricted-imports
import { Modal as AntModal } from 'antd';
import { ModalFuncProps, ModalProps } from 'antd/es/modal';
import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { ProductiveHeading05 } from 'components/styles';
import { IconShell } from '../icon-shell';
import styles from './modal.module.css';

export const defaultModalProps: ModalFuncProps = {
  okButtonProps: {
    className: styles.ok_button,
    type: 'primary',
  },
  cancelButtonProps: {
    className: styles.cancel_button,
  },
  closeIcon: <IconShell size="large" icon={<Close20 />} />,
};

// Dont use merge function, it is costly and introduces performance issues
export const Modal = styled(AntModal).attrs(
  (props: ModalProps & ModalFuncProps) => {
    _.set(
      props,
      'okButtonProps.className',
      `${styles.ok_button} ${props?.okButtonProps?.className}`,
    );
    if (!props?.okButtonProps?.type) {
      _.set(props as ModalFuncProps, 'okButtonProps.type', 'primary');
    }

    _.set(
      props,
      'cancelButtonProps.className',
      `${styles.cancel_button} ${props?.cancelButtonProps?.className}`,
    );

    if (!props?.closeIcon) {
      _.set(props, 'closeIcon', <IconShell size="large" icon={<Close20 />} />);
    }

    return props;
  },
)`
  .ant-modal-header {
    padding: var(--spacing-05);
    border: none;

    .ant-modal-title {
      ${ProductiveHeading05};
    }
  }
  .ant-modal-body {
    padding: 0 var(--spacing-05);
  }

  .ant-modal-footer {
    padding: var(--spacing-09) var(--spacing-05) var(--spacing-05);
    border: none;
  }
  .ant-modal-close-x {
    width: 48px;
    height: 48px;
    &:hover {
      background-color: var(--hover-color);
    }
  }
`;
